import * as React from 'react';

import Aljex from '../assets/aljex-logo.png';

export default function AljexLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={Aljex} alt='Aljex logo' {...props} />;
}
